import {
    FETCH_DAILY_PUSHES_REPORTS,
    FETCH_DAILY_PUSHES_REPORTS_FETCHING,
    FETCH_DAILY_PUSHES_REPORTS_SUCCESS,
    FETCH_DAILY_PUSHES_REPORTS_FAIL,
    FETCH_WEEKLY_PUSHES_REPORTS,
    FETCH_WEEKLY_PUSHES_REPORTS_FETCHING,
    FETCH_WEEKLY_PUSHES_REPORTS_SUCCESS,
    FETCH_WEEKLY_PUSHES_REPORTS_FAIL,
    FETCH_MONTHLY_PUSHES_REPORTS,
    FETCH_MONTHLY_PUSHES_REPORTS_FETCHING,
    FETCH_MONTHLY_PUSHES_REPORTS_SUCCESS,
    FETCH_MONTHLY_PUSHES_REPORTS_FAIL,
    SWITCH_PUSHES_METRIC_PERIOD
} from '../../actions/pushesActions';

import { RESET_PROFILE_PAGE } from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    dailyPushes: [],
    dailyPushesFetching: false,
    dailyPushesFetchFail: false,
    dailyPushesAverage: null,
    last7DaysAverage: null,
    weeklyPushes: [],
    weeklyPushesFetching: false,
    weeklyPushesFetchFail: false,
    monthlyPushes: [],
    monthlyPushesFetching: false,
    monthlyPushesFetchFail: false,
    metricPeriodFilter: 'weekly'
};

// Daily Fetching Handlers
const fetchDailyPushesFetching = (state) => {
    return {
        ...state,
        dailyPushesFetching: true,
        dailyPushesFetchFail: false
    };
};

const fetchDailyPushesSuccess = (state, action) => {
    if (action.isLast7Days) {
        return {
            ...state,
            last7DaysAverage: action.dailyPushes.aggregations,
            dailyPushesFetching: false,
            dailyPushesFetchFail: false
        };
    }
    return {
        ...state,
        dailyPushes: action.dailyPushes.values,
        dailyPushesAverage: action.dailyPushes.aggregations,
        dailyPushesFetching: false,
        dailyPushesFetchFail: false
    };
};

const fetchDailyPushesFail = (state) => {
    return {
        ...state,
        dailyPushesFetching: false,
        dailyPushesFetchFail: true
    };
};

//Weekly Fetching Handlers
const fetchWeeklyPushesFetching = (state) => {
    return {
        ...state,
        weeklyPushesFetching: true,
        weeklyPushesFetchFail: false
    };
};

const fetchWeeklyPushesSuccess = (state, action) => {
    return {
        ...state,
        weeklyPushes: action.weeklyPushes,
        weeklyPushesFetching: false,
        weeklyPushesFetchFail: false
    };
};

const fetchWeeklyPushesFail = (state) => {
    return {
        ...state,
        weeklyPushesFetching: false,
        weeklyPushesFetchFail: true
    };
};

//Monthly Fetching Handlers
const fetchMonthlyPushesFetching = (state) => {
    return {
        ...state,
        monthlyPushesFetching: true,
        monthlyPushesFetchFail: false
    };
};

const fetchMonthlyPushesSuccess = (state, action) => {
    return {
        ...state,
        monthlyPushes: action.monthlyPushes,
        monthlyPushesFetching: false,
        monthlyPushesFetchFail: false
    };
};

const fetchMonthlyPushesFail = (state) => {
    return {
        ...state,
        monthlyPushesFetching: false,
        monthlyPushesFetchFail: true
    };
};

const switchFilter = (state, { payload: { filter } }) => ({
    ...state,
    metricPeriodFilter: filter
});

const resetToInitialState = () => INITIAL_STATE;

//Handler Assignments
const handlers = {
    [FETCH_DAILY_PUSHES_REPORTS_FETCHING]: fetchDailyPushesFetching,
    [FETCH_DAILY_PUSHES_REPORTS_SUCCESS]: fetchDailyPushesSuccess,
    [FETCH_DAILY_PUSHES_REPORTS_FAIL]: fetchDailyPushesFail,
    [FETCH_WEEKLY_PUSHES_REPORTS_FETCHING]: fetchWeeklyPushesFetching,
    [FETCH_WEEKLY_PUSHES_REPORTS_SUCCESS]: fetchWeeklyPushesSuccess,
    [FETCH_WEEKLY_PUSHES_REPORTS_FAIL]: fetchWeeklyPushesFail,
    [FETCH_MONTHLY_PUSHES_REPORTS_FETCHING]: fetchMonthlyPushesFetching,
    [FETCH_MONTHLY_PUSHES_REPORTS_SUCCESS]: fetchMonthlyPushesSuccess,
    [FETCH_MONTHLY_PUSHES_REPORTS_FAIL]: fetchMonthlyPushesFail,
    [RESET_PROFILE_PAGE]: resetToInitialState,
    [SWITCH_PUSHES_METRIC_PERIOD]: switchFilter
};

//Default Action
export default function pushesReports(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

//Actions
export function fetchDailyPushes(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_DAILY_PUSHES_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchWeeklyPushes(payload, evictCache) {
    return {
        type: FETCH_WEEKLY_PUSHES_REPORTS,
        payload: payload,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchMonthlyPushes(payload, evictCache) {
    return {
        type: FETCH_MONTHLY_PUSHES_REPORTS,
        payload: payload,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function switchMetricFilter(payload) {
    return {
        payload,
        type: SWITCH_PUSHES_METRIC_PERIOD
    };
}

//Selectors
export const getDailyPushes = (state) => {
    if (state.pushesReports.dailyPushes) {
        return state.pushesReports.dailyPushes.map((item) => ({ calendarDate: item.calendarDate, ...item.values }));
    }
    return null;
};

export const getDailyPushesAverage = (state) => {
    return state.pushesReports.dailyPushesAverage;
};

export const getLast7DaysAverage = (state) => {
    return state.pushesReports.last7DaysAverage;
};

export const isDailyPushesFetching = (state) => {
    return state.pushesReports.dailyPushesFetching;
};

export const didDailyPushesFetchFail = (state) => {
    return state.pushesReports.dailyPushesFetchFail;
};

export const getWeeklyPushes = (state) => {
    return state.pushesReports.weeklyPushes ? state.pushesReports.weeklyPushes : null;
};

export const isWeeklyPushesFetching = (state) => {
    return state.pushesReports.weeklyPushesFetching;
};

export const didWeeklyPushesFetchFail = (state) => {
    return state.pushesReports.weeklyPushesFetchFail;
};

export const getMonthlyPushes = (state) => {
    return state.pushesReports.monthlyPushes ? state.pushesReports.monthlyPushes : null;
};

export const isMonthlyPushesFetching = (state) => {
    return state.pushesReports.monthlyPushesFetching;
};

export const didMonthlyPushesFetchFail = (state) => {
    return state.pushesReports.monthlyPushesFetchFail;
};

export const getMetricPeriodFilter = (state) => {
    return state.pushesReports.metricPeriodFilter;
};
